import React, { useState } from "react";
import { FaBars, FaPlus, FaFileImport, FaFileExport } from "react-icons/fa";
import styles from "./Header.module.scss";
import { useSidebar } from "../../SidebarContext";

const Header = ({
  title = "Default Title",
  onAddClick,
  showImportExport = false,
  onImportClick,
  onExportClick,
}) => {
  const { toggleSidebar, isCollapsed } = useSidebar(); 
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className={styles.header}>
      <FaBars className={styles.burgerMenu} onClick={toggleSidebar} />
      

      {/* {isCollapsed &&<> */}
      
        <div className={styles.title}>{title}</div>

        <div className={styles.buttons}>
          {onAddClick && (
            <button className={styles.button} onClick={onAddClick}>
              <FaPlus className={styles.icon} />
            </button>
          )}
          {showImportExport && (
            <>
              <button className={styles.button} onClick={onImportClick}>
                <FaFileImport className={styles.icon} />
              </button>
              <button className={styles.button} onClick={onExportClick}>
                <FaFileExport className={styles.icon} />
              </button>
            </>
          )}
        </div>
      {/* </>} */}
     
    </header>
  );
};

export default Header;
